import { z as zod } from 'zod';

export const sustainabilityActionCategorySchema = zod.object({
  title: zod.string(),
});
